import React from 'react';
import PropTypes from 'prop-types';
import { causeFromError, causeMeta } from '../lib/crawlFailureCauses';

/**
 * Why a crawl failed, in words, with a marker when it needs a person.
 *
 * Renders nothing for a run that didn't fail or whose error predates the
 * cause-tagging — old rows just keep showing their raw message.
 */
const CrawlFailureBadge = ({ error, showHint }) => {
  const cause = causeFromError(error);
  const meta = causeMeta(cause);
  if (!meta) return null;

  return (
    <span className="inline-flex flex-col gap-1">
      <span className="inline-flex items-center gap-1">
        <span
          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${meta.style}`}
          title={meta.hint}
        >
          {meta.label}
        </span>
        {meta.needsAttention && (
          <span
            className="text-xs font-semibold text-red-700"
            title="This will not resolve on its own"
          >
            needs attention
          </span>
        )}
      </span>
      {showHint && (
        <span className="text-xs text-gray-600">{meta.hint}</span>
      )}
    </span>
  );
};

CrawlFailureBadge.propTypes = {
  error: PropTypes.string,
  showHint: PropTypes.bool,
};

CrawlFailureBadge.defaultProps = {
  error: '',
  showHint: false,
};

export default CrawlFailureBadge;
